<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('inspection.operation.inspect') }}</div>
    <div slot="body">
      <p class="d-flex align-items-center">{{ $t('inspection.report.dialog.condition_check') }}：
        <template v-if="!isShowCheckLoading">
          <a-icon class="mr-1" type="sync" spin /> {{ $t('inspection.report.dialog.checking') }}...
        </template>
        <status v-else :specifyStatus="inspectCheckStatusMap[inspectCheckStatus]" />
      </p>
      <p>{{ $t('inspection.report.dialog.check_result') }}：</p>
      <vxe-table :data="inspectTableData">
        <vxe-table-column type="seq" width="60" :title="$t('inspection.report.columns.number')" />
        <vxe-table-column field="ip" title="IP" />
        <vxe-table-column field="status" :title="$t('inspection.report.columns.status')">
          <template v-slot="{ row }">
            <status :specifyStatus="specifyStatus[row.status]" />
          </template>
        </vxe-table-column>
        <vxe-table-column field="remark" :title="$t('inspection.report.columns.remark')" />
      </vxe-table>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading" :disabled="isInspectDisabled">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { STATUS_MAP, INSPECT_STATUS_MAP, INSPECT_CHECK_STATUS_MAP } from '../constants'

export default {
  name: 'InspectDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      specifyStatus: {
        OK: { class: 'status-success', text: this.$t('inspection.report.status.success') },
        ERROR: { class: 'status-danger', text: this.$t('inspection.report.status.error') },
      },
      inspectCheckStatusMap: {
        OK: { class: 'status-success', text: this.$t('inspection.report.dialog.success') },
        ERROR: { class: 'status-danger', text: this.$t('inspection.report.dialog.error') },
        WARNING: { class: 'status-warning', text: this.$t('inspection.report.dialog.warn') },
      },
      inspectTableData: [],
      inspectTableLoading: false,
      inspectStatus: INSPECT_STATUS_MAP.BUSY.key,
      inspectCheckStatus: '',
      inspectStatusCheckTimer: null,
      isFirstLoad: true,
    }
  },
  computed: {
    isShowCheckLoading () {
      return this.inspectCheckStatusMap[this.inspectCheckStatus]
    },
    isBusy () {
      return this.inspectStatus === INSPECT_STATUS_MAP.BUSY.key
    },
    isError () {
      return this.inspectCheckStatus === INSPECT_CHECK_STATUS_MAP.ERROR.key
    },
    isInspectDisabled () {
      if (this.inspectCheckStatus === '') return true
      return this.isBusy || this.isError
    },
  },
  created () {
    this.checkManager = new this.$Manager('checks', 'v1')
    this.init()
  },
  beforeDestroy () {
    clearInterval(this.inspectStatusCheckTimer)
  },
  methods: {
    async init () {
      await this.fetchInspectStatus()
      this.doSSHLogin()
    },
    async fetchInspectStatus () {
      const result = await this.checkManager.list({ params: { status: true } })
      this.inspectStatus = result.data.data?.[0]?.status || INSPECT_STATUS_MAP.BUSY.key
      if (this.inspectStatus === INSPECT_STATUS_MAP.IDLE.key) {
        if (!this.isFirstLoad) {
          clearInterval(this.inspectStatusCheckTimer)
          this.fetchSSHChecks()
        }
      }
    },
    async doSSHLogin () {
      if (this.inspectStatus === INSPECT_STATUS_MAP.IDLE.key) {
        await this.checkManager.create({ data: { test_ssh: true, checks: {} } })
        this.inspectStatusCheckTimer = await setInterval(() => {
          this.isFirstLoad = false
          this.fetchInspectStatus()
        }, 2 * 1000)
      }
    },
    async fetchSSHChecks () {
      this.inspectTableLoading = true
      try {
        const response = await this.checkManager.list({ params: { record_type: 'ssh_check' } })
        const results = JSON.parse(response.data.data[0].results)
        this.inspectTableData = results.Result?.map(item => {
          return {
            ip: item.Ip,
            status: item.Status === STATUS_MAP.OK.key ? item.Status : STATUS_MAP.ERROR.key,
            remark: item.Status === STATUS_MAP.OK.key ? '' : item.Status,
          }
        })
        this.inspectCheckStatus = results.Status
      } catch (error) {
        throw error
      } finally {
        this.inspectTableLoading = true
      }
    },
    async handleConfirm () {
      this.loading = true
      try {
        await this.checkManager.create({ data: { checks: {} } })
        this.params.success && this.params.success()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
